import { useCallback, type ReactNode } from 'react';
import { useNavigate, useRouter, useSearch } from '@tanstack/react-router';

import { EditorSectionContext, EditorSectionSetterContext } from './editorSectionContext';

export function EditorSectionProvider({ children }: { children: ReactNode }) {
  const search = useSearch({ strict: false });
  const navigate = useNavigate();
  const router = useRouter();
  // Stable: compares against the router's current section at call time, not a render snapshot.
  const setSection = useCallback(
    (section: string) => {
      const current = (router.state.location.search as Record<string, unknown>)['section'];
      if (section === current) return;
      void navigate({
        to: '.',
        search: (previous) => ({ ...previous, section }),
        resetScroll: false,
      });
    },
    [navigate, router],
  );
  return (
    <EditorSectionSetterContext.Provider value={setSection}>
      <EditorSectionContext.Provider value={{ section: search.section, setSection }}>
        {children}
      </EditorSectionContext.Provider>
    </EditorSectionSetterContext.Provider>
  );
}
